import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  faUsers,
  faUserFriends,
  faUserTie,
  faUserCheck,
  faTableTennis,
} from "@fortawesome/free-solid-svg-icons";

import { MetricsCompactCarousel } from "./MetricsCompactCarousel";

/**
 * Compact admin home metrics — horizontal snap strip (3 visible per snap).
 */
export const MetricsAdminHome = ({ data }) => {
  const { t } = useTranslation();

  const items = useMemo(
    () => [
      {
        key: "groups",
        icon: faUsers,
        label: t("coachMetricGroups", t("totalgrp")),
        value: data?.totalTrainingGroups ?? data?.totalGroups ?? 0,
        tone: "groups",
      },
      {
        key: "players",
        icon: faTableTennis,
        label: t("totalplayer"),
        value: data?.totalPlayers ?? 0,
        tone: "players",
      },
      {
        key: "coaches",
        icon: faUserTie,
        label: t("totalcoach"),
        value: data?.totalCoaches ?? 0,
        tone: "sessions",
      },
      {
        key: "active",
        icon: faUserCheck,
        label: t("activeplayer"),
        value: data?.monthlyActivePlayers ?? 0,
        tone: "upcoming",
      },
      {
        key: "women",
        icon: faUserFriends,
        label: t("totalwomen"),
        value: data?.womenPlayers ?? 0,
        tone: "players",
      },
    ],
    [data, t]
  );

  return <MetricsCompactCarousel items={items} />;
};
